import { createFileRoute } from "@tanstack/react-router";
import CrmLifecyclePage, { CRM_DESCRIPTION, CRM_PATH, CRM_SCHEMA, CRM_TITLE } from "@/pages/CrmLifecyclePage";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/services/crm-lifecycle")({
  head: () => ({
    ...pageHead({ path: CRM_PATH, title: CRM_TITLE, description: CRM_DESCRIPTION }),
    scripts: CRM_SCHEMA.map((s) => ({ type: "application/ld+json", children: JSON.stringify(s) })),
  }),
  component: CrmLifecyclePage,
});
